import { useNavigate } from 'react-router-dom';

import { VerticalContainer, useForm } from '@american-autonomy/ag-ui';

import Form from 'components/Form';
import FormSubmitPanel from 'components/FormSubmitPanel';
import FieldFormFields from 'components/forms/FieldFormFields';

import useField from 'hooks/useField';
import useFormDiscardConfirmation from 'hooks/useFormDiscardConfirmation';
import usePageRoutes from 'hooks/usePageRoutes';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { CreateFieldFormSchema, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CreateFieldForm: FunctionComponent<Props> = ({
    className = '',
    onCancelClose,
    onClose,
    requestingClose,
    testId = TEST_ID
}) => {
    const { createField, isLoading } = useField();
    const { CREATE } = useTranslation();
    const navigate = useNavigate();
    const { fieldDetailsPage } = usePageRoutes();

    const form = useForm<CreateFieldFormSchema>({
        mode: 'onChange'
    });

    const {
        formState: { errors, isDirty },
        handleSubmit
    } = form;

    const { confirmationPanel, showConfirmation } = useFormDiscardConfirmation({
        isDirty,
        onCancelClose,
        onClose,
        requestingClose
    });

    const onSubmit = async (data: CreateFieldFormSchema) => {
        const { farm, name } = data;

        const field = await createField({ farmId: farm.value, field: { name } });

        if (field) {
            onClose?.();
            navigate(fieldDetailsPage(field.id));
        }
    };

    return (
        <VerticalContainer className={`${styles.createFieldForm} ${className}`} testId={testId}>
            {showConfirmation ? (
                confirmationPanel
            ) : (
                <Form form={form}>
                    <FieldFormFields />

                    <FormSubmitPanel
                        buttonText={CREATE}
                        disabled={isLoading}
                        errors={errors}
                        onSubmit={handleSubmit(onSubmit)}
                    />
                </Form>
            )}
        </VerticalContainer>
    );
};

export default CreateFieldForm;
